import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class ContainerVisualization {
    @JsonProperty("componentContainer")
    componentContainer: "none" | "panel";

    @JsonProperty("showPanelTitle")
    showPanelTitle: boolean = false;

    @JsonProperty("collapsible")
    collapsible: boolean = false;

    @JsonProperty("collapsedByDefault")
    collapsedByDefault: boolean = false;
}

@JsonObject()
export class ComponentVisualization {
    @JsonProperty("container")
    container: ContainerVisualization;

    @JsonProperty("version")
    version: string;
}
